// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chevron-down-s"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15.5354 10.7345L11.9999 14.27L8.46436 10.7345","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chevron-down-s')
export default class ChevronDownSIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chevron-down-s',
    }
  }
}
